// Page Motos neuves : chaque moto est détourée (vue 8, 600 px) à l'approche de l'écran.

import { CutoutLoader } from "./cutout.js";
import { frameUrl, getCatalog, maskUrl } from "./frames.js";

const FRAME = 8;
const WIDTH = 600;
const { models } = getCatalog();
const loader = new CutoutLoader({ capacity: models.length, concurrency: 3 });

async function show(canvas) {
  const m = models.find((x) => x.id === canvas.dataset.bike);
  if (!m) return;
  try {
    const { bitmap, box } = await loader.load(m.id, frameUrl(m, FRAME, WIDTH), maskUrl(m, FRAME, WIDTH));
    // Recadrage sur la silhouette (les photos ont de larges marges blanches).
    const pad = 8;
    const x = Math.max(0, box.x0 - pad);
    const y = Math.max(0, box.y0 - pad);
    const w = Math.min(bitmap.width, box.x1 + pad) - x;
    const h = Math.min(bitmap.height, box.y1 + pad) - y;
    canvas.width = w;
    canvas.height = h;
    canvas.getContext("2d").drawImage(bitmap, x, y, w, h, 0, 0, w, h);
    canvas.closest(".bike-media")?.classList.add("is-loaded");
  } catch (err) {
    console.warn(err);
  }
}

const canvases = document.querySelectorAll("canvas[data-bike]");
if ("IntersectionObserver" in window) {
  const io = new IntersectionObserver(
    (entries) => {
      for (const e of entries)
        if (e.isIntersecting) {
          io.unobserve(e.target);
          show(e.target);
        }
    },
    { rootMargin: "400px 0px" },
  );
  canvases.forEach((c) => io.observe(c));
} else canvases.forEach(show);
